import Form from "react-bootstrap/Form";
import "../../../src/main.css";
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import PaginationDiv from "modules/pagination/PaginationDiv";
import Offcanvas from "react-bootstrap/Offcanvas";
import { EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import { useInvoiceStore } from "./store";
import { Modal } from "react-bootstrap";
import FalconCloseButton from "modules/common/FalconCloseButton";

function OffCanvas({ name, ...props }) {
  const [show, setShow] = useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [page, newPage] = useState(1);
  const [pageCountValid, setPageCountValid] = useState(1);
  const [pageValid, newPageValid] = useState(1);
  const [filterData, setFilter] = useState([]);
  const [filterDataValid, setFilterValid] = useState([]);
  const [sortData, setSortedData] = useState([]);
  const [sortDataValid, setSortedDataValid] = useState([]);
  const { invoiceUrl, downloadUrl, getInvoiceUrl, getDownloadInvoiceUrl } =
    useInvoiceStore();
  const [lgShow, setLgShow] = useState(false);
  const [image, setImage] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    setSortedData(props.record?.invalid || []);
    setSortedDataValid(props.record?.valid || []);
  }, [props.record]);

  useEffect(() => {
    if (id) {
      getDownloadInvoiceUrl({ orderDisplayId: id });
    }
  }, [id]);

  useEffect(() => {
    if (downloadUrl && id) {
      const a = document.createElement("a");
      a.download = downloadUrl.fileName;
      a.href = downloadUrl.url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setId("");
    }
  }, [downloadUrl]);

  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  useEffect(() => {
    const numOfSubarrays = Math.max(
      Math.ceil((sortDataValid?.length || 0) / 10),
      0
    );
    const arrayOfArrays = sortDataValid
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortDataValid?.slice(start, end);
        })
      : [];
    setPageCountValid(
      Math.max(Math.ceil((sortDataValid?.length || 0) / 10), 1)
    );
    setFilterValid(arrayOfArrays[pageValid - 1]);
  }, [sortDataValid, pageValid]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    const payloadData = filterDataValid?.map((item) => {
      return {
        orderDisplayId: item?.orderDisplayId,
        orderNumber: item?.orderNumber,
      };
    });
    getInvoiceUrl({ orderDisplayId: payloadData });
    setShow(true);
  };

  const showImage = (index) => {
    setImage(invoiceUrl?.invoiceURLS[index]);
    setLgShow(true);
  };

  const downloadImage = (id) => {
    setId(id);
  };


  return (
    <>
      <div variant="primary" className="me-2">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold">Invoice Data</div>
              </Tooltip>
            }
          >
            <span className="ms-2 cursor-pointer" onClick={handleShow}>
              {props?.userName}
            </span>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        style={{ width: "60%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h5 className="text-break">{props?.userName}</h5>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="d-flex gap-2">
            <div className="w-50">
              <div>
                <div>
                  <div className="fs-2 p-2 mt-n3 text-black fw-bold">
                    {props.tab === "invoice"
                      ? "Error Orders - Orders without Invoices"
                      : "Error Orders - Orders without Credit Note"}
                  </div>
                  <div
                    className="border border-rounded scrollable-container"
                    style={{
                      maxHeight: "60vh",
                      minHeight: "20vh",
                      overflowY: "scroll",
                    }}
                  >
                    <table className="table table-responsive table-striped table-bordered rounded table-hover">
                      <thead
                        style={{
                          background: "rgb(249,250,253)",
                          position: "sticky",
                          top: 0,
                        }}
                        className="rounded-top text-black p-2"
                      >
                        <tr className="d-flex fw-bold">
                          <th className="flex-1 fs-1 p-3 align-top text-center">
                            Order Display Id
                          </th>
                          <th className="flex-1 fs-1 p-3 align-top text-center ">
                            Reason
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(filterData) &&
                          filterData?.map((item, index) => (
                            <tr key={index} className="d-flex">
                              <td className="flex-1 p-3 text-black text-center">
                                {item?.orderDisplayId}
                              </td>
                              <td className="flex-1 p-3 text-black text-center text-break">
                                {item?.reason}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div>
                  <PaginationDiv
                    paginationData={{ pageCount: pageCount || 1, page: page }}
                    newPage={newPage}
                    activePage={page}
                  />
                </div>
              </div>
            </div>
            <div className="w-50">
              <div>
                <div>
                  <div className="fs-2 p-2 mt-n3 text-black fw-bold">
                    {props.tab === "invoice"
                      ? "Valid Orders - Orders with Invoices"
                      : "Valid Orders - Orders with Credit Note"}
                  </div>
                  <div
                    className="border border-rounded scrollable-container"
                    style={{
                      maxHeight: "60vh",
                      minHeight: "20vh",
                      overflowY: "scroll",
                    }}
                  >
                    <table className="table table-responsive table-striped table-bordered rounded table-hover">
                      <thead
                        style={{
                          background: "rgb(249,250,253)",
                          position: "sticky",
                          top: 0,
                        }}
                        className="rounded-top text-black p-3"
                      >
                        <tr className="d-flex fw-bold">
                          <th className="flex-1 fs-1 p-3 align-top text-center">
                            Order Display Id
                          </th>
                          <th className="flex-1 fs-1 p-3 align-top text-center ">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(filterDataValid) &&
                          filterDataValid?.map((item, index) => (
                            <tr key={index} className="d-flex">
                              <td className="flex-1 p-3 text-black text-center">
                                {item?.orderDisplayId}
                              </td>
                              <td className="flex-1 p-3 text-black text-center">
                                <div className="d-flex gap-4 align-items-center justify-content-center">
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => showImage(index)}
                                  >
                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip
                                          style={{ position: "fixed" }}
                                          id="overlay-trigger-example"
                                        >
                                          <div className="fw-bold">View Invoice</div>
                                        </Tooltip>
                                      }
                                    >
                                      <EyeOutlined />
                                    </OverlayTrigger>
                                  </div>
                                  <div
                                    className="cursor-pointer"
                                    onClick={() =>
                                      downloadImage(item?.orderDisplayId)
                                    }
                                  >
                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip
                                          style={{ position: "fixed" }}
                                          id="overlay-trigger-example"
                                        >
                                          <div className="fw-bold">Download Invoice</div>
                                        </Tooltip>
                                      }
                                    >
                                      <DownloadOutlined />
                                    </OverlayTrigger>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div>
                  <PaginationDiv
                    paginationData={{
                      pageCount: pageCountValid || 1,
                      page: pageValid,
                    }}
                    newPage={newPageValid}
                    activePage={pageValid}
                  />
                </div>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            Invoice
          </Modal.Title>
          <FalconCloseButton onClick={() => setLgShow(false)} />
        </Modal.Header>
        <Modal.Body>
          <embed
            src={image}
            type="application/pdf"
            width={"98%"}
            height={600}
          ></embed>
        </Modal.Body>
      </Modal>
    </>
  );
}

function InvoiceCanvas({ userName, record, tab }) {
  return (
    <>
      <OffCanvas
        key={6}
        userName={userName}
        record={record}
        tab={tab}
        placement={"end"}
        name={"Filter"}
      />
    </>
  );
}

export default InvoiceCanvas;
